import React, { useState } from "react";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useNavigate } from "react-router-dom";

const ConnectYourBusiness = ({ setBusinessType }) => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const userTypes = [
    {
      title: "Add Your Website",
      description: "Your business website URL",
      type: "url",
    },
    {
      title: "Upload a file",
      description: "Eg. Price list, brochure, sales pitch etc ",
      type: "file",
    },
    {
      title: "Tell Us More",
      description: "Answer some questions so we can get to know you ",
      type: "detail",
    },
  ];

  return (
    <div>
      <div>
        <div className="container-main" style={{ background: "white" }}>
          <div className="container" style={{ background: "white" }}>
            <div className="">
              <div className="text-center pb-5">
                <h1 className="text-[30px] font-medium">Train Your AI</h1>
                <p className="mt-4">
                  Select one of these three options to personalise Your AI
                  instantly
                </p>
              </div>

              <div className="flex flex-col items-center">
                {userTypes.map((item, index) => (
                  <div key={index} className="group">
                    <div
                      onClick={() => setBusinessType(item?.type)}
                      className="w-[420px] h-[108px] mt-5 border border-[#D9D9D9] group-hover:bg-[#F6F0FF] group-hover:border-[#9747FF] pl-[35px] pr-7 rounded-md flex items-center justify-between cursor-pointer"
                    >
                      <div className="flex flex-col items-start gap-3">
                        <b>{item.title}</b>
                        <p className="text-sm">{item.description}</p>
                      </div>
                      <div className="hidden group-hover:flex">
                        <ArrowForwardOutlinedIcon className="text-[20px]" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span
        onClick={() => navigate(-1)}
        className="text-[#757575] text-[12px] mt-8 ml-8 cursor-pointer flex float-start"
      >
        ← Go back
      </span>
    </div>
  );
};

export default ConnectYourBusiness;
